import React from 'react';

import { SuccessComponent } from '../features/payment/components/SuccessComponent';

const SuccessPage = () => {
  return <SuccessComponent />;
};

export default SuccessPage;
